/* eslint-disable ember/no-computed-properties-in-native-classes, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';
import ProgressionType from '@linc-technologies/linced-common/enums/progression-type';
import {
  getDataCardPromises,
  loadSavedPreferences,
} from 'linced-app/utils/data-cards';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class DataWallRoute extends Route {
  // Services
  @service
  dates;

  @service
  fetch;

  @service
  heroApi;

  @service
  personOptions;

  @service
  session;

  @service
  store;

  @service
  terms;

  @alias('session.school.jurisdiction')
  jurisdiction;

  model() {
    let group = super.model(...arguments);
    let progressionType = ProgressionType.PROGRESSION;

    let {
      grades,
      subjectSummaries,
      subjectProgressions,
      attendanceSummaries,
      attendanceDays,
    } = getDataCardPromises(this, {
      attendance: true,
      grades: true,
      progressions: true,
      summaries: true,
    });

    return hash({
      group,
      assessments: this.store.findAll('assessments/assessment'),
      modules: this.store.findAll('assessments/module'),
      gradeSchedules: this.store.findAll('assessments/grade-schedule'),
      timeframes: this.store
        .query('timeframe', { schoolId: group.get('school.id') })
        .then((timeframes) =>
          timeframes.slice().sort((a, b) => a.startDateUnix - b.startDateUnix),
        ),
      grades,
      expectations: this.store.findAll('milestones/expectation'),
      allSubjects: this.store.findAll('goals/subject'),
      categories: this.store.findAll('goals/category'),
      allGoals: this.store.findAll('goals/goal'),
      levels: this.store.findAll('milestones/level'),
      milestones: this.store.query('milestones/milestone', {
        progressionType,
      }),
      milestoneSets: this.store.query('milestones/milestone-set', {
        include: 'milestones',
      }),
      subjectProgressions,
      subjectSummaries,
      terms: this.terms.waitUntilLoaded(),
      attendanceSummaries,
      attendanceDays,
    });
  }

  setupController(controller, model) {
    super.setupController(controller, model);

    // Load saved options from the personOptions service.
    loadSavedPreferences(controller, model, [
      'assessmentIds',
      'assessmentModuleIds',
      'subjectIds',
      'progressIds',
    ]);
  }
}
